import React from 'react';
export default class DropDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showOptions: false,
    };
    this.handleVisibilityClick = this.handleVisibilityClick.bind(this);
    this.loseFocus = this.loseFocus.bind(this);
    this.selectedValue = this.selectedValue.bind(this);
  }

  handleVisibilityClick() {
    this.setState({
      showOptions: !this.state.showOptions
    });
  }

  loseFocus(e) {
    
    if ((e.relatedTarget && e.relatedTarget.href) || (document.activeElement && document.activeElement.href)) {
      return e.preventDefault();
    }
    this.setState({
      showOptions: false
    });
  }
  selectedValue(e) {
    this.props.handleChange(e.target.getAttribute('value'));
    this.handleVisibilityClick()   
  }
  //TODO: expose an actual select html element for mobile browsers that support it natively
  render() {
    if (!this.props.items) {
      return null;
    }
    let stateClass = this.state.showOptions ? 'state-up' : 'state-down';
    return (
      <div id="dd"
        className={`controls dropdown-container1 ${stateClass}`}
        tabIndex="0"
        onBlur={this.loseFocus}
      >
        <div
          className={`select-dropdown contained ${stateClass}`}
          onClick={this.handleVisibilityClick}
        >
          {this.props.label}
          <img className="arrow-down" alt="up" src="/img/arrow-up.png" />
          <img className="arrow-up" alt="down" src="/img/arrow-down.png" />
        </div>
        <ul className="option-list">
          {
            this.props.items.map((item, index) => {            
              return (
                <li onClick={this.selectedValue} key={index} value={item.link}>
                  {item.label}
                </li>               
              );
            })
          }
        </ul>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/shared/controls/drop-down.jsx